// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"246":"b59c5e5f","676":"6c3bf6fb"}[chunkId] + ".chunk.js";
};